import { __ } from "@wordpress/i18n";
import Button from "../Common/Button";
import ModalContainer from "../Global/ModalContainer";

const UpsellPopupModal = ( props ) => {

    const upsellModal = props.upsellModal;
    const upsellContent = upsellModal.upsellActive !== false && props?.upsellContent[upsellModal.upsellActive] !== undefined ? props?.upsellContent[upsellModal.upsellActive] : null;
    const upsellContentList = [
        __('Use multiple TikTok accounts', 'sb-customizer'),
        __('Moderate and filter feeds', 'sb-customizer'),
        __('Show like and view counts', 'sb-customizer'),
        __('More frequent updates', 'sb-customizer'),
        __('Sort by likes and views', 'sb-customizer'),
        __('Infinitely load more videos', 'sb-customizer'),
        __('List and carousel layouts', 'sb-customizer'),
        __('Show captions', 'sb-customizer'),
        __('Pro support', 'sb-customizer')
    ]

    const includedButtons = upsellContent?.buttons ? Object.keys(upsellContent?.buttons) : [];

    const upgradeProNotice = (
        <span className = "sb-lite-btn-texts"> 
            {__('Lite Plugin Users get 50% OFF', 'sb-customizer')}
            <span className="sb-lite-btn-discount-applied">
                {__('auto-applied at checkout', 'sb-customizer')}
            </span>
        </span>
    );

    return (
        (upsellModal.upsellActive !== false && upsellContent !== null )&&
            <ModalContainer
                size='medium'
                closebutton={true}
                onClose={ () => {
                    upsellModal.setUpsellActive( false )
                } }
            >

                <div className='sb-upsell-modal sb-fs'>
                    <div className='sb-upsell-modal-top sb-fs'>
                        <div className='sb-upsell-modal-heading sb-fs'>
                            <h2 className="sb-fs sb-h2">{ upsellContent.heading }</h2>
                            {
                                upsellContent.description &&
                                <p className="sb-fs sb-text-tiny sb-dark2-text">{ upsellContent.description }</p>
                            }
                            {
                                includedButtons.includes('lite') &&
                                <Button
                                    customClass='sb-upgrade-lite-btn'
                                    size='medium'
                                    text={upgradeProNotice}
                                    icon='tag'
                                    boxshadow={false}
                                    link={upsellContent?.buttons['lite']}
                                    target={upsellContent?.buttons['lite'] ? '_blank' : false}
                                />
                            }
                        </div>
                        {
                            upsellContent?.image &&
                            <div className='sb-upsell-modal-image sb-fs'>
                                <img src={ window.sb_customizer.assetsURL + 'sb-customizer/assets/images/' + upsellContent?.image } alt={__( 'Upsell Modal Icon', 'sb-customizer' )} />
                            </div>
                        }
                    </div>
                    {
                        upsellContent?.includeContent === true &&
                        <div className='sb-upsell-modal-content sb-fs'>
                            <strong>{ __('And get much more!', 'sb-customizer') }</strong>
                            <div className='sb-upsell-modal-content-list sb-fs'>
                                {
                                    upsellContentList.map( (elm, key) => {
                                        return (
                                            <span className='sb-dark2-text sb-text-small ' key={key}>{ elm }</span>
                                        )
                                    } )
                                }
                            </div>
                        </div>
                    }
                    {
                        ( includedButtons.includes('upgrade') || includedButtons.includes('demo') ) &&
                        <div className='sb-upsell-modal-action-btns sb-fs'>
                            {
                                includedButtons.includes('upgrade') &&
                                <Button
                                    customClass='sb-upsell-act-btn'
                                    size='large'
                                    type='upgrade'
                                    text={ __('Upgrade', 'sb-customizer') }
                                    icon='logo-white'
                                    link={upsellContent?.buttons['upgrade']}
                                    target={upsellContent?.buttons['upgrade'] ? '_blank' : false}
                                />
                            }
                            {
                                includedButtons.includes('demo') &&
                                <Button
                                    customClass='sb-upsell-act-btn'
                                    size='large'
                                    type='secondary'
                                    text={ __('Video Demo', 'sb-customizer') }
                                    icon='eye'
                                    link={upsellContent?.buttons['demo']}
                                    target={upsellContent?.buttons['demo'] ? '_blank' : false}
                                />
                            }
                            {
                                includedButtons.includes('learnMore') &&
                                <Button
                                    customClass='sb-upsell-act-btn'
                                    size='large'
                                    type='secondary'
                                    text={__('Learn More', 'sb-customizer')}
                                    icon='chevron-right'
                                    iconSize='7'
                                    icon-position='right'
                                    link={upsellContent?.buttons['learnMore']}
                                    target={upsellContent?.buttons['learnMore'] ? '_blank' : false}
                                />
                            }
                        </div>
                    }
                </div>

            </ModalContainer>
    )
}

export default UpsellPopupModal;
